import React from 'react';
import { Box } from '@material-ui/core';
import { ColorLegend } from '../../../common/ColorLegend';

const ENTRIES: { color: string; text: string }[] = [
  { color: '#A7D6FC', text: 'Available' },
  { color: '#F4DA75', text: 'Pending' },
  { color: '#ABDC40', text: 'Joined' },
];

export function RolesColorLegend() {
  return (
    <Box display='flex' flexWrap='wrap'>
      {ENTRIES.map((entry) => (
        <ColorLegend
          key={entry.text}
          color={entry.color}
          text={entry.text}
          width={10}
          height={10}
          isRound
          marginRight='6px'
        />
      ))}
    </Box>
  );
}
